export const RESUME_OPTIONS = [
  {
    id: 'ml',
    label: 'ML Resume',
    href: '/Sudharshan-Ramesh-Resume-ML.pdf',
    description: 'Research, model training, MLOps, and applied machine learning.',
  },
  {
    id: 'sde',
    label: 'SDE Resume',
    href: '/Sudharshan-Ramesh-Resume-SDE.pdf',
    description: 'Systems, product engineering, frontend/backend, and shipping.',
  },
];
